<template lang='pug'>
.agreement-slide-out(:class='{ "has-agreement" : asset !== null }')
	asset-slide-out(
		:state='state'
		:asset='asset'
		:asset-key='assetKey'
		:asset-name='assetName'
		@close='$emit( "close" )'
		@edit='$emit( "edit" )'
		@delete='$emit( "delete" )'
	)

		.title-container(
			slot='title'
		)
			h1.title Agreement

		p.loading-indicator.spacey(
			v-if='dataState === "loading"'
			slot='side-sheet-content'
		) Loading
			span .
			span .
			span .

		p.failed.spacey(
			slot='side-sheet-content'
			v-if='dataState === "failed"'
		) Failed to load agreement

		page.agreements-page.side-sheet-content(
			slot='side-sheet-content'
			v-if='dataState === "loaded"'
			:tabs='tabs'
		)

			.body-wrapper(slot='main-body')
				agreement(
					v-if='asset'
					:agreement='asset'
				)

			.body(slot='tab-comments' v-if='asset')
				comments(
					:section-id='`agreements-${assetKey}`'
					:user='user'
					@replied-to-comment='email'
				)

			.body.documents.separate-gradient.down(slot='tab-documents' v-if='asset')
				document-list(
					:documents='asset.folder'
					:a-files='asset.file'
					:assetKey='asset.agreementsKey'
					@close='$emit( "close" )'
				)
</template>

<script>
import AssetSlideOut from '@/components/slide-outs/AssetSlideOut';
import Agreement from '@/components/slide-outs/agreements/Agreement';
import SideSheet from '@/components/SideSheet';
import Comments from '@/components/comments';
import Page from '@/components/Page';
import DocumentList from '@/components/DocumentList';

import { objectOrNull } from '@/lib/vue-validators';

import { SendEmail } from '@/lib/API';

export default {
	name : 'agreement-slide-out',

	props : {
		state : {
			type     : String,
			required : true,
		},

		dataState : {
			type     : String,
			required : true,
		},

		asset : {
			required  : true,
			validator : objectOrNull,
		},

		assetKey : {
			required : true,
		},

		assetName : {
			required : true,
		},
	},

	data : () => ( {
		infoState : 'closed',
		tabs      : {
			'comments'  : 'Comments',
			'documents' : 'Documents',
		},
	} ),

	computed : {

		user() {
			// console.log( 'This is the Agreement Postgres User~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~' );
			// console.log( this.$store.state.postgresUser );
			return this.$store.state.postgresUser;
		}

	},

	methods : {

		addClass() {
			this.infoState = ( this.infoState === 'open' ) ? 'closed' : 'open';
		},

		email( recipientKey, link ) {
			const { asset } = this;

			const sectionDescription = `Agreement GIS #${asset.gisReference}`;

			const emailData = {
				sectionDescription,
				link
			};

			SendEmail( this.user.usersKey, [recipientKey], 'reply', emailData );
		}

	},

	components : {
		AssetSlideOut,
		Agreement,
		SideSheet,
		Comments,
		Page,
		DocumentList
	}
};
</script>

<style lang='scss'>
.agreement-slide-out {

	&:not(.has-agreement) {

		.toggle,
		.main {
			opacity: 0;
		}
	}

	.side-sheet .swipers .swiper-wrapper .swiper-slide:not(:nth-child(1)) {
		overflow-y: scroll;
		background: white;
	}

	.body-wrapper {
		width: 100%;

		.loading-indicator {
			text-align: center;
		}
	}

	p.loading-indicator {
		text-align: center;
	}

	.body {

		.document-list {
			padding: 15px;
		}

		.comment-section {

			.separate-gradient {

				&::before {
					height: 250px; // we just put this here to let the gradient have a better look by being bigger
					background: linear-gradient(180deg, rgba(228, 248, 224, 0.61) 0%, rgba(247, 253, 246, 0.303867) 25.41%, rgba(255, 255, 255, 0) 100%), #FFFFFF;
				}
			}

			> .comment-thread-container {

				> .comment-thread {
					padding: 15px;
				}
			}
		}

		> p.spacey {
			text-align: center;
		}
	}
}
</style>
